<!--  https://play.tailwindcss.com/T3roE6ewD2 -->

<template>
  <nav
    v-motion="useAnimation(0, 'opacity')"
    class="
      fixed left-0 top-0 z-30 flex w-full select-none items-center justify-start bg-white py-6
      pr-container-mobile-level-1 text-lg
      teacher:text-violet-text
      student:text-white
      lg:pr-container-desktop-level-2
    "
    role="navigation"
  >
    <div
      class="
        shrink-0.5 grow-0 pl-container-mobile-level-1 pr-4
        lg:basis-container-desktop-level-4 lg:pl-container-desktop-level-2
      "
    >
      <DynLink
        :to="auth.homepage"
        aria-label="to the Dashboard"
        class="group shrink-0 grow-0 ring-offset-8 focus:outline-none"
      >
        <IconLogo
          class="
            h-5.5 ring-offset-4
            group-focus-visible:ring-2 group-focus-visible:ring-focusTeacher
            min-[860px]:h-6
            lg:h-7
          "
          type="teacher"
        />
        <IconTrialLogo v-if="auth.staff?.organisation?.is_trial" />
      </DynLink>
    </div>
    <menu class="flex shrink grow-4 -translate-x-2 lg:gap-1">
      <li
        v-for="{ page } in cms.globals?.main?.tree"
        :key="page.id"
        class="flex flex-wrap"
      >
        <DynLink
          :to="page.url"
          tabindex="-1"
          aria-label="hidden"
          class="
            peer pointer-events-none pl-2 font-bold opacity-0 typo-body-l-medium
            focus:outline-none
            min-[860px]:typo-body-xl-medium
          "
        >
          {{ page.title }}
        </DynLink>
        <DynLink
          :to="page.url"
          role="menuitem"
          :aria-label="`to the ${page.title} page`"
          class="
            peer absolute mx-auto ml-2 rounded text-violet-text ring-focusTeacher ring-offset-4
            typo-body-l-medium
            hover:text-violet-800
            focus:outline-none
            focus-visible:ring-2
            link-active:font-bold
            min-[860px]:typo-body-xl-medium
          "
        >
          {{ page.title }}
        </DynLink>
        <DynLink
          :to="page.url"
          tabindex="-1"
          aria-label="hidden"
          class="w-5 focus:outline-none"
        />
      </li>
    </menu>

    <User />
  </nav>
</template>

<script lang="ts" setup>
const cms = useCmsStore()
const auth = useAuthStore()
</script>
